const countdownElements = document.querySelectorAll(".countdown-element");

if (countdownElements.length > 0) {
  countdownElements.forEach(countdown => {

const rawDate = countdown.dataset.time;
    console.log("Fecha recibida:", rawDate); // <-- depuración

    // Evitar NaN
    if (!rawDate) {
      console.error("No se ha definido data-date en el HTML");
      return;
    }

    const targetDate = new Date(rawDate);

    if (isNaN(targetDate)) {
      console.error("Formato de fecha inválido:", rawDate);
      return;
    }

    const daysElement = countdown.querySelector("#days");
    const hoursElement = countdown.querySelector("#hours");
    const minutesElement = countdown.querySelector("#minutes");
    const secondsElement = countdown.querySelector("#seconds");

    const updateCountdown = () => {
      const now = new Date().getTime();
      const diff = targetDate - now;

      if (diff <= 0) {
        daysElement.textContent = "00";
        hoursElement.textContent = "00";
        minutesElement.textContent = "00";
        secondsElement.textContent = "00";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      daysElement.textContent = String(days).padStart(2, "0");
      hoursElement.textContent = String(hours).padStart(2, "0");
      minutesElement.textContent = String(minutes).padStart(2, "0");
      secondsElement.textContent = String(seconds).padStart(2, "0");
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
}
